export default __webpack_public_path__ + "static/ff-events-c56981668712e3dd99451d7c31a2f4aa.webp";